export function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 bg-white shadow rounded text-gray-800">
      <h1 className="text-2xl font-bold border-l-4 border-[#07cc55] pl-3 mb-6">利用規約</h1>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">第1条（適用範囲）</h2>
      <p>
        本規約は、ボドゲ診断（以下「当サイト」といいます）が提供するサービスの利用条件を定めるものであり、ユーザーの皆さまに適用されます。
      </p>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">第2条（サービス内容）</h2>
      <p>
        当サイトでは、ボードゲームに関する情報提供および性格診断形式のコンテンツを提供しています。診断結果に基づき外部サイト（Amazon等）へのリンクを掲載することがあります。
      </p>
      <p>
        本サービスはあくまでエンターテインメントを目的としており、医学的・心理学的根拠に基づくものではありません。診断結果はあくまで参考としてお楽しみください。
      </p>
      <p>
        当サイトではサービスの品質向上のため、診断内容・ロジック・診断結果・掲載コンテンツ（ボードゲーム情報など）を予告なく変更・更新・削除する場合があります。
      </p>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">第3条（禁止事項）</h2>
      <p>ユーザーは以下の行為を行ってはなりません。</p>
      <ul className="list-disc list-inside ml-4">
        <li>本サービスの内容を無断で転載・複製・販売・加工する行為</li>
        <li>自動取得プログラム（スクレイピング等）による情報収集</li>
        <li>他のユーザーや第三者に不利益または損害を与える行為</li>
        <li>法令または公序良俗に反する行為</li>
        <li>その他、運営者が不適切と判断する行為</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">第4条（免責事項）</h2>
      <ul className="list-disc list-inside ml-4">
        <li>診断結果の正確性・有用性について一切保証するものではありません。</li>
        <li>当サイトからリンクされた外部サイト（例：Amazon等）の内容について、当サイトは一切の責任を負いません。</li>
        <li>ユーザーが本サービスを利用して作成・共有した診断結果等について、SNS等での拡散に伴う第三者とのトラブルに関して当サイトは責任を負いません。</li>
        <li>本サービスの利用により生じた損害について、当サイト運営者は一切の責任を負いません。</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">第5条（広告・アフィリエイトについて）</h2>
      <p>
        当サイトでは、一部のコンテンツにおいてアフィリエイトリンク等の広告を掲載することがあります。広告のクリックや商品の購入により、当サイトが報酬を得る場合があります。
        表示された予算と実際の販売価格が一致しない場合がありますので、あらかじめご了承ください。また、掲載されたボードゲームが売り切れまたは取扱終了となっている場合もあります。
        当サイトでは、外部サービスにおける在庫状況や販売状況について一切の責任を負いません。
      </p>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">第6条（知的財産権）</h2>
      <p>
        当サイトに掲載されている文章、画像、ロゴ、キャラクター、デザイン等のコンテンツの著作権およびその他知的財産権は、当サイト運営者または正当な権利者に帰属します。  
        これらを無断で転載、複製、改変、販売、またはAI等の機械学習に利用することを禁止します。
      </p>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">第7条（サービスの変更・中止）</h2>
      <p>
        当サイトは、事前の通知なしにサービスの全部または一部を変更・停止・終了することがあります。
      </p>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">第8条（準拠法・管轄）</h2>
      <p>
        本規約は日本法に準拠し、当サイトに関する一切の紛争については、運営者の所在地を管轄する日本の裁判所を第一審の専属的合意管轄裁判所とします。
      </p>

      <p className="mt-8 text-sm text-gray-600">
        制定日：2025年7月1日<br />
        運営者：ボドゲ診断運営チーム<br />
        お問い合わせ先：<a href="mailto:info@bodogeshindan.jp" className="text-[#269d53] underline">info@bodogeshindan.jp</a>
      </p>
    </div>
  );
}